<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>THÊM NHÂN VIÊN</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-6 pt-6 pb-0">
        <v-form v-bind="this.$attrs" ref="form">
          <v-text-field
            label="Tên đăng nhập"
            v-model="username"
            outlined
            required
            class="required"
            :rules="[$rules.required]"
          ></v-text-field>
          <v-text-field
            label="Họ tên"
            required
            type="tel"
            v-model="name"
            class="required"
            :rules="[$rules.required]"
            outlined
          ></v-text-field>
          <v-text-field
            label="Email"
            type="email"
            v-model="email"
            outlined
            class="required"
            required
            :rules="[$rules.required, $rules.email]"
          ></v-text-field>

          <v-select
            label="Vai trò"
            :items="roles"
            item-text="type"
            item-value="id"
            v-model="role"
            class="required"
            outlined
            required
            :rules="[$rules.role]"
          ></v-select>

          <v-text-field
            label="Mật khẩu"
            v-model="password"
            outlined
            required
            class="required"
            :rules="[$rules.nospace, $rules.required, $rules.minLength(6)]"
          ></v-text-field>
          <v-text-field
            label="Nhập lại mật khẩu"
            v-model="password2"
            required
            class="required"
            :rules="[$rules.nospace, $rules.required, $rules.minLength(6), $rules.passInputAgain(password2, password)]"
            outlined
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" dark @click="submit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  props: {
    state: Boolean,
    roles: Array
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) this.loading = false
    }
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  data() {
    return {
      dialog: false,
      loading: false,
      name: '',
      username: '',
      email: '',
      role: '',
      password: '',
      password2: ''
    }
  },
  methods: {
    ...mapActions('user', ['createUser']),
    close() {
      this.$emit('closeDialog')
      this.$refs.form.resetValidation()
    },
    async submit() {
      if (this.$refs.form.validate()) {
        let data = {
          name: this.name,
          username: this.username,
          email: this.email,
          role: this.role,
          password: this.password
        }

        const createLead = await this.createUser({...data})

        if (createLead) {
          this.$emit('refresh')
          this.resetForm()
          this.close()
        } else {
          this.$alert.error('Lỗi tạo khách hàng')
        }
      }
    },
    resetForm() {
      this.name = ''
      this.username = ''
      this.email = ''
      this.role = ''
      this.password = ''
    }
  }
}
</script>

<style>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 2px !important;
}
</style>
